<template>
    <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 mb-5">
        {{refresh}}
        <!--<div class="card card-noticias">
            <img :src="rutafile+form.Imagen" class="card-img-top " alt="ENES" @click="Ver">
            <div class="card-body">
                <h5 class="card-title medium color_Azul">{{form.Titulo}} </h5>
                <div class="color_Gris02">
                    <div class="description" v-html="$options.filters.subStr(form.Descripcion)" style="margin-bottom:-15px"></div>
                    <a @click="Ver" href="javascript:0">Leer más</a>
                </div>
                <p class="color_Gris02 mt-3"><i class="far fa-calendar-alt color_Negro"></i> {{form.Tiempo}}</p>
            </div>
        </div>-->

        <div class="card card-noticias box-imge-noticias">
            <img :src="rutathumbnail+form.Imagen" class="card-img-top pointer" alt="ENES" @click="Ver">
            <div class="card-body">
                <h5 class="card-title medium color_Azul" :title='form.Titulo'>{{form.Titulo}}</h5>
                <div class="color_Gris02">
                    <div class="description" v-html="$options.filters.subStr(form.Descripcion)" style="margin-bottom:-15px"></div>
                    <a @click="Ver" href="javascript:0">Leer más</a>
                </div>
                <p class="color_Gris02"><i class="far fa-calendar-alt color_Negro"></i> {{form.Tiempo}}</p>
            </div>
        </div>
                
        <modal-component v-if="showModal" @cerrar="showModal = false" size='modal-lg'>
			<template slot="titulo" >
                Notica
            </template>
			<template slot="contenido" >
                <h4 class="color_Azul">{{form.Titulo}}</h4>
                <hr class="titulo_hr">
                <div class="row justify-content-center">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <figure>
                            <img :src="rutafile+form.Imagen" alt="Difusión" class="w-100">
                        </figure>
                    </div>
                </div>
                <div class="description" v-html="form.Descripcion"></div>
			</template>
		</modal-component>
    </div>
</template>

<script>
import ModalComponent from "@/components/ModalComponent";
export default {
    components:{
        ModalComponent
    },
    props:['value','rutafile','rutathumbnail'],
    data() {
        return {
            form:this.value,
            showModal:false
        }
    },
    methods: {
        Ver(){
            this.showModal = true;
        },
    },
    filters: {
        subStr: function(string2) {
            let add = '';
            let string = (string2 == null || string2 == undefined)?'':string2;
            if(string !='')
                if(string.length>270)
                    add = '...';
            return string.substring(0,270)+add;
        }
    },
    computed:{
        refresh: function(){
            this.form = this.value;
        }
    }
}
</script>